import { render, staticRenderFns } from "./index.vue?vue&type=template&id=49a31653"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49a31653')) {
      api.createRecord('49a31653', component.options)
    } else {
      api.reload('49a31653', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=49a31653", function () {
      api.rerender('49a31653', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/sign/record/index.vue"
export default component.exports